import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PushNotifications, PushNotificationSchema } from '@capacitor/push-notifications';
import { IonicModule, ModalController, Platform } from '@ionic/angular';
import { StorageService } from '../services/storage.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-notification-center',
  templateUrl: './notification-center.component.html',
  styleUrls: ['./notification-center.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule]
})
export class NotificationCenterComponent implements OnInit {

  private modalController = inject(ModalController);
  private platform = inject(Platform);
  private router = inject(Router);
  private storage = inject(StorageService);

  @Input() notifications: PushNotificationSchema[] = [];
  @Input() modalMode = false;
  constructor() { }

  async ngOnInit() {
    if (!this.notifications && this.platform.is('ios') || !this.notifications && this.platform.is('android')) {
      this.getNotifications();
    }
  }

  async ionViewWillEnter() {
    this.notifications = await this.storage.get('notifications');
  }

  async getNotifications() {
    PushNotifications.getDeliveredNotifications().then(async (res) => {
      if (res.notifications) {
        for (const notification of res.notifications) {
          this.storage.storeNotification('notifications', notification);
        }
        this.notifications = await this.storage.get('notifications');
      }
    });
  }

  async deleteNotification(notification: PushNotificationSchema) {
   this.notifications = await this.storage.deleteNotification('notifications', notification);
   PushNotifications.removeDeliveredNotifications({notifications: [notification]});
  }

  async clearNotifications() {
    await this.storage.remove('notifications');
    PushNotifications.removeAllDeliveredNotifications();
    this.notifications = null;
  }

  navigateToEventPage(notification: PushNotificationSchema) {
    if (notification.data.eventPage) {
      this.router.navigateByUrl('events/' + notification.data.eventPage, {replaceUrl: true, skipLocationChange: true});
    }
  }

  closeModal() {
    this.modalController.dismiss(null, 'cancel');
  }


}
